var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEveningIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 52,
  viewBox: "0 0 52 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5434 7.03879C23.3205 6.81365 23.9385 7.63558 23.676 8.4009C22.3856 12.1635 22.6677 16.4429 24.8126 20.1583C27.4805 24.7792 32.345 27.341 37.3257 27.2872C38.1347 27.2784 38.7223 28.1229 38.266 28.7909C37.0989 30.4993 35.5406 31.9794 33.629 33.0831C26.8105 37.0196 18.092 34.6837 14.1553 27.8653C10.2189 21.047 12.555 12.3284 19.3731 8.39165C20.3946 7.80189 21.4589 7.35296 22.5434 7.03879Z",
  fill: "#0F8B9E"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 33.6523H46.11",
  stroke: "#87C5CE",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5454 38.9531L40.8067 38.9531",
  stroke: "#87C5CE",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9336 38.9531L22.9012 38.9531",
  stroke: "#87C5CE",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9585 44.2598L18.9261 44.2598",
  stroke: "#87C5CE",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5669 44.2598L26.2192 44.2598",
  stroke: "#87C5CE",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})));
export default SvgEveningIcon;